/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { notify } from '../functions/notifications';
import Firebase from '../services/firebase';
import FirebaseContext from '../context/firebase.context';
import UsuarioContext from '../context/usuario.context';
import CidadesContext from '../context/cidades.context';
import {
  constantes, RECORDS, PERMITIDOS, PERMITIDOS_APLICADOR, PERMITIDOS_APLICADOR_PRODUTOR,
} from '../constantes';
import { EnviarNotificacao } from '../services/apiWhats';
import { DataAtual } from '../functions/helper';

export function ProviderFirebase({ children }) {
  const {
    usuario, setUsuario, setCadastrado,
    setAmountNotifications, setUserLocation,
  } = useContext(UsuarioContext);
  const { setActualLocation } = useContext(CidadesContext);
  const [logado, setLogado] = useState(false);
  const [loading, setLoading] = useState(false);
  const [permissoes, setPermissoes] = useState([]);
  const [listMessage, setListMessage] = useState(false);
  const [positionViwerActive, setPositionViwerActive] = useState([]);
  const [positionViwerInative, setPositionViwerInative] = useState([]);
  const [listUsuarios, setListUsuarios] = useState([]);
  const [expectadores, setExpectadores] = useState([]);
  const { aguardandoAtivacao } = constantes;
  const history = useHistory();
  function Logout() {
    Firebase.auth().signOut().then(() => {
      setLogado(false);
      setLoading(false);
    });
  }
  function getRecordsActive() {
    Firebase.firestore()
      .collection('users')
      .get()
      .then((result) => {
        const envios = result.docs.map((user) => user.data().records);
        const markers = envios.map((mark) => (mark.marker.length > 0) && mark.marker);
        const poligon = envios.map((pol) => (pol.poligon.length > 0) && pol.poligon);

        const markerAndPoligon = [...markers, ...poligon];
        const listPosition = [];
        markerAndPoligon.forEach((listMarkerAndPoligon) => {
          if (listMarkerAndPoligon) {
            listMarkerAndPoligon.forEach((position) => {
              const key = Object.keys(position);
              const { active } = position[`${key}`];
              if (active) {
                listPosition.push(position);
              }
            });
          }
        });
        setPositionViwerActive(listPosition);
      });
  }
  function getRecordsInative() {
    Firebase.firestore()
      .collection('users')
      .get()
      .then((result) => {
        const envios = result.docs.map((user) => user.data().records);
        const markers = envios.map((mark) => (mark.marker.length > 0) && mark.marker);
        const poligon = envios.map((pol) => (pol.poligon.length > 0) && pol.poligon);

        const markerAndPoligon = [...markers, ...poligon];
        const listPosition = [];
        markerAndPoligon.forEach((listMarkerAndPoligon) => {
          if (listMarkerAndPoligon) {
            listMarkerAndPoligon.forEach((position) => {
              const key = Object.keys(position);
              const { active } = position[`${key}`];
              if (!active) {
                listPosition.push(position);
              }
            });
          }
        });
        setPositionViwerInative(listPosition);
      });
  }
  function ListnnerNotifications(props) {
    const { uid, notifications } = usuario;
    const db = Firebase.firestore();

    if (notifications) {
      db.collection('users').doc(uid).onSnapshot((doc) => {
        const { notifications: msgs } = doc?.data() || [];
        if (msgs?.length > 0) {
          const mensagens = Object.entries(msgs).map(([key, value]) => value)
            .map((value) => Object.values(Object.values(value)));
          const nofitications = mensagens.filter((element) => element[0].read === false).length;

          const returnMsg = Object.entries(msgs).map(([key, value]) => value)
            .map((value) => Object.values(Object.values(value))[0]);

          returnMsg.forEach((valor, geralLoop) => {
            returnMsg.forEach((value, positionLoop) => {
              if ((valor?.data && value?.data) && valor?.data < value?.data) {
                const control = returnMsg[geralLoop];
                returnMsg[geralLoop] = returnMsg[positionLoop];
                returnMsg[positionLoop] = control;
              }
            });
          });
          setUsuario((prevState) => ({
            ...prevState, notifications: msgs,
          }));
          setAmountNotifications(nofitications);
          setListMessage(returnMsg);
          getRecordsActive();
          getRecordsInative();
        } else {
          setAmountNotifications(0, setListMessage([]));
        }
      }, (error) => {
        if (error.message === 'Missing or insufficient permissions') {
          setAmountNotifications(0, setListMessage([]));
        }
      });
    }
  }
  async function EfetuarLogin() {
    const verificarUsuario = Yup.object().shape({
      email: Yup.string().required(),
      senha: Yup.string().required(),
    });

    setLoading(true);
    if ((await verificarUsuario.isValid(usuario))) {
      const { email, senha } = usuario;
      return Firebase.auth().signInWithEmailAndPassword(email, senha).then(() => {
        const { uid } = Firebase.auth().currentUser;
        Firebase.firestore().collection('users').doc(uid).get()
          .then((dados) => {
            const usuarioLogado = dados.data();
            if (usuarioLogado) {
              const ativo = usuarioLogado.ativo || false;
              if (ativo) {
                Firebase.firestore().collection('administradores').doc('usuarios').get()
                  .then((listaAdmins) => {
                    const { uid: listaAdminstradores } = listaAdmins.data();
                    const superUsuario = listaAdminstradores.some((result) => result === uid);
                    setUsuario({ ...usuarioLogado, superUsuario });
                  });
              }
              setLoading(false);
              setLogado(true);
            } else {
              setLoading(false);
            }
          });
      }).catch((erro) => {
        switch (erro.message) {
          case 'There is no user record corresponding to this identifier. The user may have been deleted.':
            notify('error', 'Usuário não encontrado');
            break;
          case 'The email address is badly formatted.':
            notify('error', 'Email com formato inválido');
            break;
          case 'The password is invalid or the user does not have a password.':
            notify('error', 'Usuário não encontrado');
            break;
          default:
            notify('error', erro.message);
            break;
        }
        setLoading(false);
      });
    }
    setLoading(false);
    return notify('error', 'O email e a senha são obrigatórios');
  }
  async function VerificaLogin(verificacao) {
    useEffect(() => {
      Firebase.auth().onAuthStateChanged((user) => {
        const uid = user ? user.uid : 'deslogado';
        if (uid !== 'deslogado') {
          Firebase.firestore().collection('users').doc(uid).get()
            .then((dados) => {
              if (dados.data()) {
                const usuarioLogado = dados.data();
                const isActive = usuarioLogado.ativo || false;
                if (isActive) {
                  Firebase.firestore().collection('administradores').doc('usuarios').get()
                    .then((listaAdmins) => {
                      const { uid: listaAdminstradores } = listaAdmins.data();
                      const superUsuario = listaAdminstradores.some((result) => result === uid);
                      setUsuario({ ...usuarioLogado, superUsuario });
                      setUserLocation({
                        latitude: usuarioLogado.latitude,
                        longitude: usuarioLogado.longitude,
                        cidade: usuarioLogado.cidade,
                        estado: usuarioLogado.estado,
                      });
                      setLogado(true);
                      if (usuarioLogado.state === 'Aguardando Ativação') {
                        setUsuario({
                          activation_code: usuarioLogado.activation_code,
                          email: usuarioLogado.email,
                          ativo: usuarioLogado.ativo,
                          celular: usuarioLogado.celular,
                          uid: usuarioLogado.uid,
                          nome: usuarioLogado.nome,
                          idUsuario: usuarioLogado.idUsuario,
                          state: usuarioLogado.state,
                          superUsuario,
                        });
                        setLogado(false);
                        return history.push('/cadastro/confirmacao');
                      }
                      if (usuarioLogado.tipoDeCadastro === 'Coleta') {
                        setActualLocation([usuarioLogado.latitude, usuarioLogado.longitude]);
                        setLogado(true);
                        return history.push('/coleta');
                      }
                      setActualLocation([usuarioLogado.latitude, usuarioLogado.longitude]);
                      setLogado(true);
                      return history.push('/dashboard');
                    });
                }
              } else {
                Firebase.firestore().collection('users').doc(uid).get()
                  .then((result) => {
                    const temInfo = result.data();
                    if (!temInfo) {
                      const { currentUser: { email } } = Firebase.auth();
                      setUsuario({ email });
                      setLogado(false);
                      history.push('/cadastro');
                    } else {
                      setLoading(false);
                    }
                  });
                setLoading(false);
              }
            });
        } else {
          setUsuario({});
          setLogado(false);
          setLoading(false);
          if (verificacao === 'confirmacao' && !logado) {
            history.push('/login');
          }
        }
      });
    }, [usuario.state]);
  }
  const setarNoBanco = () => {
    const newCodeConfirm = (Math.floor(Math.random() * 9999));
    const novoIdUsuario = Firebase.auth().currentUser.uid;
    const { aplicador, aplicadorProdutor } = constantes.classificacao;
    let premissoes = [];
    if (usuario.tipo === aplicador) {
      premissoes = PERMITIDOS_APLICADOR;
    } else if (usuario.tipo === aplicadorProdutor) {
      premissoes = PERMITIDOS_APLICADOR_PRODUTOR;
    } else {
      premissoes = PERMITIDOS;
    }
    let newId;
    Firebase.firestore().collection('next_id').doc('next').get()
      .then(async (resultado) => {
        newId = resultado.data().valor;
      })
      .then(() => {
        const novoUsuario = {
          email: usuario.email,
          celular: usuario.whatsApp,
          nome: usuario.nome,
          state: aguardandoAtivacao,
          activation_code: newCodeConfirm,
          idUsuario: newId,
          premissoes,
          records: RECORDS,
          ativo: true,
          uid: novoIdUsuario,
          vendas: [],
        };
        Firebase.firestore().collection('users').doc(novoIdUsuario).set(novoUsuario)
          .then(() => {
            setUsuario('novoUsuario', novoUsuario);
            newId += 1;
            Firebase.firestore().collection('next_id').doc('next').update({ valor: newId })
              .then(() => {
                EnviarNotificacao(
                  {
                    telefone: usuario.whatsApp,
                    nome: usuario.nome,
                    codigo: newCodeConfirm,
                  },
                );
                setLoading(false);
                setCadastrado(true);
                setLogado(true);
                history.push('/dashboard');
              });
          });
      })
      .catch((err) => {
        notify('error', `Erro ao registrar os dados do usuário no sistema: ${err}`);
      });
  };
  async function Cadastrar() {
    const verificarUsuario = Yup.object().shape({
      nome: Yup.string().required(),
      email: Yup.string().required(),
      whatsApp: Yup.string().required(),
      senha: Yup.string().required(),
      contraSenha: Yup.string().required(),
    });
    setLoading(true);
    if ((await verificarUsuario.isValid(usuario))) {
      if (usuario.contraSenha === usuario.senha) {
        if (!logado) {
          Firebase.auth().createUserWithEmailAndPassword(usuario.email, usuario.senha).then(() => {
            setarNoBanco();
          })
            .catch((erro) => {
              setLoading(false);
              switch (erro.message) {
                case 'Password should be at least 6 characters':
                  notify('error', 'A senha deve ter pelo menos 6 caracteres!');
                  break;
                case 'The email address is already in use by another account.':
                  notify('error', 'Este email já está sendo utilizado por outro usuário!');
                  break;
                case 'The email address is badly formatted.':
                  notify('error', 'O formato do seu email é inválido!');
                  break;
                default:
                  notify('error', 'Um erro inesperado aconteceu, tente novamente mais tarde.');
                  break;
              }
            });
        } else {
          setarNoBanco();
        }
      } else {
        setLoading(false);
        notify('error', 'As senhas não conferem');
      }
    } else {
      notify('error', 'Todos os campos são obrigatórios');
    }
  }
  async function UpdateUser({ update, setDesabilitado }) {
    const verificarUsuario = Yup.object().shape({
      activation_code: Yup.number().required(),
      ativo: Yup.boolean().required(),
      celular: Yup.string().required(),
      email: Yup.string().required(),
      idUsuario: Yup.number().required(),
      nome: Yup.string().required(),
      state: Yup.string().required(),
      superUsuario: Yup.boolean().required(),
      uid: Yup.string().required(),
    });
    const { uid } = usuario;
    setLoading(true);
    usuario.tipoDeCadastro = usuario.tipoDeCadastro.replace(' / Produtor', '');
    if ((await verificarUsuario.isValid(usuario))) {
      Firebase.firestore().collection('users').doc(uid).update(usuario)
        .then(() => {
          history.push('/dashboard');
          setLoading(true);
          if (setDesabilitado) setDesabilitado(true);
          if (update) notify('success', 'Dados atualizados com sucesso');
        })
        .catch(() => {
          notify('error', 'Erro ao atualizar o usuário');
        });
    } else {
      notify('error', 'Todos os campos são obrigatórios');
    }
  }
  function SavePositions() {
    const { uid } = usuario;
    Firebase.firestore().collection('users').doc(uid).update(usuario)
      .then(() => {
        notify('success', 'Dados Salvos');
      })
      .catch(() => {
        notify('error', 'Erro ao atualizar o usuário');
      });
  }
  async function GetPermissoes() {
    const { uid } = usuario;
    const db = Firebase.firestore();
    db.collection('users').doc(uid)
      .get((doc) => {
        const { premissoes: lista } = doc.data();
        setPermissoes(lista);
      });
  }
  async function MarcarLida({ index, uid: uidItem }) {
    const { notifications, uid } = usuario;

    if (!notifications[index][uidItem].read) {
      const actualNotification = notifications;
      actualNotification[index][uidItem].read = true;
      Firebase.firestore().collection('users').doc(uid).update({ ...usuario, notifications: actualNotification })
        .then(() => {})
        .catch(() => {
          notify('error', 'Erro ao marcar como lida');
        });
    }
  }
  async function DeleteCadastro({ type, uid: uidItem }) {
    const { records: { marker, poligon }, uid } = usuario;

    const recordsNew = type === 'marker'
      ? marker.filter((item) => !item[`${uidItem}`] && item)
      : poligon.filter((item) => !item[`${uidItem}`] && item);

    const typeUpdate = type === 'marker'
      ? { poligon, [`${type}`]: recordsNew }
      : { marker, [`${type}`]: recordsNew };

    Firebase.firestore().collection('users').doc(uid)
      .update({ ...usuario, records: typeUpdate })
      .then(() => {
        setUsuario((prevState) => ({
          ...prevState, records: typeUpdate,
        }));
      })
      .catch(() => {
        notify('error', 'Erro ao marcar como lida');
      });
  }
  async function DeleteItem({ type, uid: uidItem, uidUser }) {
    const { records: { marker, poligon }, uid } = usuario;

    const recordsNew = type === 'marker'
      ? marker.filter((item) => !item[`${uidItem}`] && item)
      : poligon.filter((item) => !item[`${uidItem}`] && item);

    const typeUpdate = type === 'marker'
      ? { poligon, [`${type}`]: recordsNew }
      : { marker, [`${type}`]: recordsNew };

    Firebase.firestore().collection('users').doc(uidUser)
      .update({ ...usuario, records: typeUpdate })
      .then(() => {
        setUsuario((prevState) => ({
          ...prevState, records: typeUpdate,
        }));
      })
      .catch(() => {
        notify('error', 'Erro ao marcar como lida');
      });
  }
  async function ExcluirMensagem({ uid: uidItem }) {
    const { notifications, uid } = usuario;
    const actualNotification = notifications
      .filter((msgm) => Object.keys(msgm)[0] !== uidItem && msgm);

    Firebase.firestore().collection('users')
      .doc(uid).update({ ...usuario, notifications: actualNotification })
      .then(() => {
        notify('success', 'Mensagem excluída');
      })
      .catch(() => {
        notify('error', 'Erro ao excluir');
      });
  }
  async function ReproveCad(obj) {
    const registro = obj;
    registro.active = true;
    Firebase.firestore().collection('users').doc(registro.uidUsuario).get()
      .then((dados) => {
        const userUpdate = dados.data();
        const atualMarkers = userUpdate.records.marker;
        const atualPoligon = userUpdate.records.poligon;

        if (obj.type === 'marker') {
          atualMarkers.forEach((item, curr) => {
            const key = Object.keys(item);
            if (key[0] === obj.uid) {
              const resultado = Object.values(item)[0];
              resultado.active = false;
              resultado.dataAprov = '00/00/0000';
              atualMarkers[curr] = { [`${key[0]}`]: resultado };
            }
          });
        } if (obj.type === 'poligon') {
          atualPoligon.forEach((item, curr) => {
            const key = Object.keys(item);
            if (key[0] === obj.uid) {
              const resultado = Object.values(item)[0];
              resultado.active = false;
              resultado.dataAprov = '00/00/0000';
              atualPoligon[curr] = { [`${key[0]}`]: resultado };
            }
          });
        }

        Firebase.firestore().collection('users').doc(userUpdate.uid)
          .update({
            ...userUpdate,
            records: {
              marker: atualMarkers,
              poligon: atualPoligon,
            },
          })
          .then(() => {
            getRecordsActive();
            getRecordsInative();
            notify('success', 'Registro bloqueado');
          })
          .catch(() => {
            notify('error', 'Erro ao bloquear o registro');
          });
      });
  }
  async function AproveCad(obj) {
    const registro = obj;
    registro.active = true;
    Firebase.firestore().collection('users').doc(registro.uidUsuario).get()
      .then((dados) => {
        const userUpdate = dados.data();
        const atualMarkers = userUpdate.records.marker;
        const atualPoligon = userUpdate.records.poligon;

        if (obj.type === 'marker') {
          atualMarkers.forEach((item, curr) => {
            const key = Object.keys(item);
            if (key[0] === obj.uid) {
              const resultado = Object.values(item)[0];
              resultado.active = true;
              resultado.dataAprov = DataAtual();
              atualMarkers[curr] = { [`${key[0]}`]: resultado };
            }
          });
        } if (obj.type === 'poligon') {
          atualPoligon.forEach((item, curr) => {
            const key = Object.keys(item);
            if (key[0] === obj.uid) {
              const resultado = Object.values(item)[0];
              resultado.active = true;
              resultado.dataAprov = DataAtual();
              atualPoligon[curr] = { [`${key[0]}`]: resultado };
            }
          });
        }

        Firebase.firestore().collection('users').doc(userUpdate.uid)
          .update({
            ...userUpdate,
            records: {
              marker: atualMarkers,
              poligon: atualPoligon,
            },
          })
          .then(() => {
            notify('success', 'Registro habilitado');
            getRecordsActive();
            getRecordsInative();
          })
          .catch(() => {
            notify('error', 'Erro ao habilitado o registro');
          });
      });
  }
  async function DeleteCadAdmin(obj) {
    const registro = obj;
    registro.active = true;
    Firebase.firestore().collection('users').doc(registro.uidUsuario).get()
      .then((dados) => {
        const userUpdate = dados.data();
        let atualMarkers = userUpdate.records.marker;
        let atualPoligon = userUpdate.records.poligon;

        if (obj.type === 'marker') {
          atualMarkers = atualMarkers.filter((item) => {
            const key = Object.keys(item);
            if (key[0] !== obj.uid) {
              const resultado = Object.values(item)[0];
              return { [`${key[0]}`]: resultado };
            }
            return false;
          });
        } if (obj.type === 'poligon') {
          atualPoligon = atualPoligon.filter((item) => {
            const key = Object.keys(item);
            if (key[0] !== obj.uid) {
              const resultado = Object.values(item)[0];
              return { [`${key[0]}`]: resultado };
            }
            return false;
          });
        }

        Firebase.firestore().collection('users').doc(userUpdate.uid)
          .update({
            ...userUpdate,
            records: {
              marker: atualMarkers,
              poligon: atualPoligon,
            },
          })
          .then(() => {
            notify('success', 'Registro excluído');
            getRecordsActive();
            getRecordsInative();
          })
          .catch(() => {
            notify('error', 'Erro ao excluít o registro');
          });
      });
  }

  useEffect(() => {
    getRecordsActive();
    getRecordsInative();
  }, []);

  useEffect(() => {
    ListnnerNotifications();
  }, [logado]);

  useEffect(() => {
    Firebase.firestore().collection('users').get().then((result) => {
      const users = result.docs.map((user) => ({
        nome: user.data().nome,
        celular: user.data().celular,
        cidade: user.data().cidade,
        estado: user.data().estado,
        uid: user.data().uid,
      }));
      setListUsuarios(users);
    });
  }, [usuario.uid]);

  useEffect(() => {
    Firebase.firestore().collection('expectador').onSnapshot((result) => {
      const expect = result.docs.map((user) => user.data());
      setExpectadores(expect);
    });
  }, [usuario.uid]);

  const shared = {
    logado,
    loading,
    Logout,
    EfetuarLogin,
    VerificaLogin,
    setarNoBanco,
    Cadastrar,
    UpdateUser,
    MarcarLida,
    ExcluirMensagem,
    DeleteCadastro,
    SavePositions,
    permissoes,
    GetPermissoes,
    ReproveCad,
    AproveCad,
    positionViwerActive,
    setPositionViwerActive,
    positionViwerInative,
    setPositionViwerInative,
    ListnnerNotifications,
    DeleteItem,
    DeleteCadAdmin,
    listMessage,
    listUsuarios,
    setListUsuarios,
    expectadores,
    setExpectadores,
  };

  return (
    <>
      <FirebaseContext.Provider value={{ ...shared }}>
        {children}
      </FirebaseContext.Provider>
    </>
  );
}
ProviderFirebase.propTypes = {
  children: PropTypes.node.isRequired,
};
